module.exports = __webpack_public_path__ + "img/virtual_kit.ea06e04a.png";